import React from 'react';
import { Button, ButtonMembership, Image, NonDismissibleOverlay, T } from '@colonist/ui';
import IconDisableAdBlock from '@static/images/icon_no_ads.svg';
import styles from './NonDismissibleAdblockOverlay.module.scss';
/** Non-dismissible overlay blocking until adblock is disabled. */ export function NonDismissibleAdblockOverlay({ open, onDisableAdblock, onBecomeMember }) {
    if (!open) return null;
    return /*#__PURE__*/ React.createElement(NonDismissibleOverlay, {
        backgroundOpacity: "translucent"
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.imageTitle
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.icon,
        image: {
            src: IconDisableAdBlock,
            alt: 'strings:popups.disableAdBlock.title'
        }
    }), /*#__PURE__*/ React.createElement("h2", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.title'
        }
    }))), /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.hardPopupBody'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.actions
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        size: "md",
        fullWidth: true,
        onClick: onDisableAdblock
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.disableButton'
        }
    })), /*#__PURE__*/ React.createElement(ButtonMembership, {
        variant: "plus",
        size: "md",
        fullWidth: true,
        onClick: onBecomeMember
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.disableAdBlock.becomeMemberButton'
        }
    }))));
}
